<app-menu [hasChanges]="loadMenu" title="Resumen ventas vs. metas"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-fluid pl-2 flex flex-wrap align-items-center h-screen">
    <div class="w-full md:w-8 pr-3 mx-auto">
        <div class="">
            <label>Seleccione la fecha de consulta</label>
            <div class="p-field flex">
                <span class="p-input-icon-left w-full">
                    <p-datepicker #calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
                        inputId="range" dateFormat="yy-mm-dd" [showIcon]="true" (onSelect)="validateMeta()">
                    </p-datepicker>
                </span>
                <button pButton icon="pi pi-search" class="p-button p-button-success"
                    (click)="getInfoVentas(false)"></button>
            </div>
        </div>
        <div class="w-full text-center">
            <button class="p-button p-button-link w-auto" pButton label="Asignar metas" icon="pi pi-percentage"
                (click)="asignarMetas()" *ngIf="isVisibleBtnMeta"></button>
        </div>
    </div>
</div>
<hr>
<div class="grid">
    <div class="col-12 md:col-6" *ngFor="let item of lsTienda; let i= index;">
        <p-card class="border-round text-center auto mt-2">
            <ng-template #header class="mt-2 pt-2">
                <h4>Tienda : {{item.nombreTienda}}</h4>
                <p>Dirección: {{item.direccion}}</p>
                <h4>Venta total: {{item.valorTotal ?? 0 | currency}} | Meta: {{(item.meta ?? 0) | currency}}</h4>
                <button *ngIf="item.hasOwnProperty('discriminacionPagos') && item.discriminacionPagos.length > 0"
                    class="p-button p-button-link colorSimescco2" (click)="showInfoDetail(i)">Ver información detallada
                    de las
                    ventas</button>
            </ng-template>
            <div>
                <div class="m-3 flex flex-row w-8 mx-auto"
                    *ngIf="item.hasOwnProperty('discriminacionPagos') && item.discriminacionPagos.length > 0">
                    <div class="flex-1 text-center">Metodo de pago</div>
                    <div class="flex-1 text-center">Valor</div>
                </div>
                <div class="flex flex-row w-8 mx-auto" *ngFor="let data of item.discriminacionPagos">
                    <div class="flex-1 text-left pl-2">{{data.referencia}}</div>
                    <div class="flex-1 text-right pr-2">{{data.valor | currency}}</div>
                </div>
            </div>
            <div class="mx-auto">
                <div class="card flex justify-content-center">
                    <apx-chart [colors]="chartOptions.fill.colors"
                        [series]="!item.chartOptions ? chartOptions.series : item.chartOptions?.series"
                        [chart]="chartOptions.chart" [labels]="chartOptions.labels" [title]="chartOptions.title"
                        #chart></apx-chart>
                    <!-- <p-chart type="pie" [data]="item.data" [options]="options"></p-chart> -->
                </div>
            </div>
            <div *ngIf="item.hasOwnProperty('discriminacionPagos') && item.discriminacionPagos.length ==0"
                class="p-message p-message-warn">No
                se han realizado ventas</div>
        </p-card>
    </div>

</div>

<p-dialog header="Listado de tiendas" [(visible)]="display" [style]="{width: '90vw'}" [modal]="true"
    (onHide)="hideDisplay()">
    <h3>Asignación de metas para el día {{dateQuery | date}}</h3>
    <div class="w-full" *ngFor="let row of lsTienda; let index = index">
        <h4>Tienda : {{row.nombreTienda}}</h4>
        <div class="p-inputgroup">
            <div class="p-inputgroup-addon">Meta a asignar: </div>
            <div class="w-full">
                <p-inputNumber [(ngModel)]="row.valorMeta" (onBlur)="setMeta(index)" (onFocus)="iniMeta(index)"
                    class="w-full">
                </p-inputNumber>
            </div>
            <div *ngIf="row.set" class="p-inputgroup-addon"><i [ngStyle]="{color:'var(--green-500)'}"
                    class="pi pi-check-circle"></i>
            </div>
        </div>
    </div>
    <ng-template #footer>
        <button pButton icon="pi pi-times-circle" label="Cerrar" (click)="display=false"></button>
    </ng-template>
</p-dialog>


<p-dialog header="Detallado ventas para el día {{dateQuery | date}}" [(visible)]="display1" [style]="{width: '90vw'}"
    [modal]="true">
    <div>
        <label>Tienda : {{tiendaSelected.nombreTienda}}</label>
        <div class="w-7 mx-auto">
            <h4>Formas de Pago</h4>
            <div class="flex gap-1"
                *ngIf="tiendaSelected.hasOwnProperty('discriminacionPagos') && tiendaSelected.discriminacionPagos.length > 0">
                <div class="flex-1 text-center uppercase">Metodo de pago</div>
                <div class="flex-1 text-center uppercase">Valor</div>
            </div>
            <div class="flex gap-1 " *ngFor="let data of tiendaSelected.discriminacionPagos">
                <div class="flex-1 text-left pl-2">{{data.referencia}}</div>
                <div class="flex-1 text-right pr-2">{{data.valor | currency}}</div>
            </div>
            <div class="flex">
                <div class="flex-1 text-left pl-2">
                    <h3 class="uppercase">Total venta</h3>
                </div>
                <div class="flex-1 text-right pr-2">
                    <h3>{{tiendaSelected.valorTotal ?? 0 | currency}}</h3>
                </div>
            </div>
        </div>

        <div class="w-7 mx-auto">
            <h4>Abonos a cartera</h4>
            <div class="flex gap-1 w-8"
                *ngIf="tiendaSelected.hasOwnProperty('infoAbonosCartera') && tiendaSelected.infoAbonosCartera.length > 0">
                <div class="flex-1 text-center">Metodo de pago</div>
                <div class="flex-1 text-center">Valor</div>
            </div>
            <div class="flex w-8" *ngFor="let data of tiendaSelected.infoAbonosCartera">
                <div class="flex-1 text-left pl-2">{{data.metodoPago.metodoPago}}</div>
                <div class="flex-1 text-right pr-2">{{data.valor | currency}}</div>
            </div>
            <div class="flex">
                <div class="flex-1 text-left pl-2">
                    <h3 class="uppercase">Total venta</h3>
                </div>
                <div class="flex-1 text-right pr-2">
                    <h3>{{tiendaSelected.totalAbonos ?? 0 | currency}}</h3>
                </div>
            </div>
        </div>

        <hr>
        <div class="p-5 mx-auto">
            <div class="text-center" id="vendedor">
                <h4 class="uppercase">Discriminación por vendedor</h4>
                <span [innerHtml]="messageSales"></span>
                <div class="grid" *ngFor="let row of infoVentaSales">
                    <div class="col-6">
                        {{row.empleado.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.nombres}}
                        {{row.empleado.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.apellidos}}
                    </div>
                    <div class="col-6">
                        {{row.subtotal + (row.impuesto ?? 0) | currency}}
                    </div>
                </div>
                <div class="grid">
                    <div class="col-6">
                        <h4>TOTAL VENTA</h4>
                    </div>
                    <div class="col-6">
                        <h4>{{ tiendaSelected.valorTotal | currency}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>